import getUUID from '@gc-npm/utils.monitoring.get-uuid';
import Sonda from '@gc-npm/utils.monitoring.sonda';
import { calculateHeaderParams } from '@gc-npm/node.build-process.build-environments';
import Request from '@gc-npm/utils.fetch';
import { FAMILY_API } from '@gc-npm/utils.enums.environment';

const PATH = '/options/FOOTER_LEGAL_COL';
const PATH_PROD = 'https://bus.telefonicaseguros.es/services/mobile-services/options/FOOTER_LEGAL_COL';
const METHOD = 'GET';
const EVENT_NAME = 'MOBILE_INSURANCE.GET_MOBILE_INSURANCE';

export const getMobileInsuranceLegals = ({
  data,
  context,
  build = false,
  idFront = 'VT',
  onSuccess,
}) => {
  const { productOffering, storage } = data;

  const { seguros: connectionData } = context.environment;
  const { endpoint: host } = connectionData;

  const processName = 'ADABYRON-API';

  const idRequest = getUUID(idFront);
  const headers2Use = calculateHeaderParams(build, FAMILY_API.TELCO, context);

  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const URL_API = `${host}${PATH}/${productOffering}/${storage}?${idRequest}`;
  //const URL_API = `${PATH_PROD}/${productOffering}/${storage}?${idRequest}`;

  const request = new Request({
    method: METHOD,
    endpoint: URL_API,
    sonda,
    build,
    headers: headers2Use,
    onSuccess,
  });

  return request.makeRequest();
};

export default getMobileInsuranceLegals;
